import { useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { changeNum, isValidCardNumber } from './common/function';
import { buildPolicyMap, filterInstallmentOptions, getPolicyNotice, isQuotaAllowed, makePolicyFromMerchantPolicy } from './common/manualCardPolicy';

function SugiInbiz() {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [bank, setBank] = useState("");
    const [cardPolicyMap, setCardPolicyMap] = useState({});

    const userData = JSON.parse(localStorage.getItem("userId")) || {};
    const isKayu = userData?.kayu === 1;

    const [formData, setFormData] = useState({
        GoodsName: "",
        price: "",
        qty: "",
        BuyerName: "",
        card_num: "",
        CardPw: "",
        ExpMonth: "",
        ExpYear: "",
        card_gubun: "개인",
        IDNo: "",
        CardQuota: "00",
        phonePre: "010",
        phoneBody: "",
    });

    // 금액 표시용
    const [displayPrice, setDisplayPrice] = useState("");

    useEffect(() => {
        dispatch(change_Current_Location("수기결제"));
        dispatch(changeHeaderTitle({ mainTitle: "수기결제", subTitle: "" }));
        CheckManualCardPolicy();
        setTimeout(() => setLoading(false), 500);
    }, [dispatch]);

    const CheckManualCardPolicy = async () => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/manual-card-policy/list",
                {},
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setCardPolicyMap(buildPolicyMap(tmp?.data?.policies ?? []));
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setCardPolicyMap({});
            }
        } catch (error) {
            console.error(error);
            setCardPolicyMap({});
        }
    };

    const CheckBank = async (eightDigits) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card/card-info",
                { withCredentials: true, params: { cardNumber: eightDigits } }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setBank(tmp?.data[0]?.card ?? "");
            } else {
                setBank("유효하지 않습니다.");
            }
        } catch (error) {
            console.error(error);
            setBank("");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // 가격 입력 (콤마 표시)
    const handlePriceChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 9);
        setFormData(prev => ({ ...prev, price: numeric }));
        setDisplayPrice(numeric ? parseInt(numeric, 10).toLocaleString("ko-KR") : "");
    };

    // 수량 입력 (숫자만)
    const handleQtyChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 4);
        setFormData(prev => ({ ...prev, qty: numeric }));
    };

    // 카드번호 입력 (하이픈 자동 포맷, 내부는 숫자만 저장)
    const [cardDisplay, setCardDisplay] = useState("");
    const [cardError, setCardError] = useState("");
    const formatCardNumber = (digits) => {
        const parts = [];
        for (let i = 0; i < digits.length; i += 4) {
            parts.push(digits.slice(i, i + 4));
        }
        return parts.join("-");
    };
    const handleCardNumChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 16);
        setCardDisplay(formatCardNumber(numeric));
        setFormData(prev => ({ ...prev, card_num: numeric }));

        if (numeric.length >= 8) {
            CheckBank(numeric.slice(0, 8));
        } else {
            setBank("");
        }

        if (numeric.length >= 15) {
            if (!isValidCardNumber(numeric)) {
                setCardError("유효하지 않은 카드번호입니다.");
            } else {
                setCardError("");
            }
        } else {
            setCardError("");
        }
    };

    // 연락처 뒷번호
    const handlePhoneBodyChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 8);
        setFormData(prev => ({ ...prev, phoneBody: numeric }));
    };

    // 사업자등록번호 (숫자만, 10자리)
    const handleIDNoChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 10);
        setFormData(prev => ({ ...prev, IDNo: numeric }));
    };

    // 결제금액 합계
    const totalAmt = (parseInt(formData.price || "0", 10) * parseInt(formData.qty || "0", 10));
    const displayTotal = totalAmt > 0 ? changeNum(totalAmt) + "원" : "";

    // 순차 validation → 버튼 텍스트
    const getValidationMessage = () => {
        if (!formData.GoodsName.trim()) return "상품명을 입력해주세요.";
        if (!formData.price) return "판매가격을 입력해주세요.";
        if (!formData.qty) return "수량을 입력해주세요.";
        if (!formData.card_num || formData.card_num.length < 15) return "카드번호를 입력해주세요.";
        if (!formData.ExpMonth || !formData.ExpYear) return "유효기간을 입력해주세요.";
        if (!isKayu && !formData.CardPw) return "비밀번호를 입력해주세요.";
        if (!formData.phoneBody) return "연락처를 입력해주세요.";
        if (!formData.BuyerName.trim()) return "이름을 입력해주세요.";
        if (!isKayu && formData.card_gubun === "개인" && !formData.IDNo) return "생년월일을 입력해주세요.";
        if (!isKayu && formData.card_gubun === "사업자" && !formData.IDNo) return "사업자등록번호를 입력해주세요.";
        return null;
    };

    const quotaOptions = [
        { value: "00", label: "일시불" },
        ...Array.from({ length: 9 }, (_, i) => {
            const month = i + 2;
            const padded = String(month).padStart(2, "0");
            return { value: padded, label: `${padded}개월` };
        }),
    ];
    const currentCardPolicy = makePolicyFromMerchantPolicy(bank, cardPolicyMap[bank]);
    const currentQuotaOptions = filterInstallmentOptions(quotaOptions, currentCardPolicy?.max_installment);
    const cardPolicyNotice = getPolicyNotice(currentCardPolicy);
    const isCardBlocked = currentCardPolicy?.usable === false;
    const validationMsg = isCardBlocked ? (cardPolicyNotice || "해당 카드는 사용할 수 없습니다.") : getValidationMessage();
    const isFormValid = validationMsg === null;

    useEffect(() => {
        if (!isQuotaAllowed(formData.CardQuota, currentCardPolicy?.max_installment)) {
            setFormData((prev) => ({ ...prev, CardQuota: "00" }));
        }
    }, [currentCardPolicy?.max_installment, formData.CardQuota]);

    // 결제 요청
    const onSubmitSugi = async () => {
        if (isSubmitting || !isFormValid) return;
        if (!isValidCardNumber(formData.card_num)) {
            setMessage({ msg: "카드번호를 확인해주세요." });
            return;
        }
        if (isCardBlocked) {
            setMessage({ msg: cardPolicyNotice || "해당 카드는 사용할 수 없습니다." });
            return;
        }
        setIsSubmitting(true);
        setLoading(true);

        const phone = formData.phonePre + formData.phoneBody;

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi",
                {
                    payerName: formData.BuyerName,
                    payerEmail: "",
                    payerTel: phone,
                    cardNumber: formData.card_num,
                    cardExpiry: formData.ExpYear + formData.ExpMonth,
                    cardCvv: "",
                    installment: formData.CardQuota,
                    products: [
                        {
                            prodId: "",
                            name: formData.GoodsName,
                            qty: parseInt(formData.qty || "1", 10),
                            price: formData.price,
                            desc: "수기결제",
                        },
                    ],
                    metadata: {
                        cardAuth: "true",
                        authPw: formData.CardPw,
                        authDob: formData.IDNo,
                    },
                    amount: String(totalAmt),
                },
                { withCredentials: true }
            );

            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setFormData({
                    GoodsName: "", price: "", qty: "",
                    BuyerName: "", card_num: "", CardPw: "",
                    ExpMonth: "", ExpYear: "", card_gubun: "개인",
                    IDNo: "", CardQuota: "00", phonePre: "010", phoneBody: "",
                });
                setDisplayPrice("");
                setCardDisplay("");
                setBank("");
                setMessage({ msg: "수기결제성공" });
            } else {
                const result = tmp?.data?.response?.result;
                setMessage({
                    msg:
                        result?.advanceMsg?.trim() ||
                        result?.resultMsg?.trim() ||
                        tmp?.msg ||
                        "수기결제실패",
                });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    // 섹션 스타일
    const sectionStyle = {
        background: "#fff",
        borderRadius: "12px",
        padding: "20px 16px",
        marginBottom: "12px",
    };
    const sectionTitle = {
        fontSize: "17px",
        fontWeight: "700",
        marginBottom: "16px",
    };
    const labelStyle = {
        fontSize: "13px",
        fontWeight: "600",
        color: "#555",
        marginBottom: "6px",
        display: "block",
    };
    const inputStyle = {
        width: "100%",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "10px 12px",
        fontSize: "15px",
        outline: "none",
        background: "#fff",
        boxSizing: "border-box",
    };
    const selectStyle = {
        ...inputStyle,
        appearance: "none",
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><path d='M4 6l4 4 4-4' stroke='%23999' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 10px center",
        backgroundSize: "16px",
    };
    const rowStyle = {
        display: "flex",
        gap: "10px",
        marginBottom: "12px",
    };
    const fieldWrap = {
        marginBottom: "12px",
    };

    return (
        <div className="flex overflow-hidden">
            {loading && <LoadingModal />}
            <MessageModal message={message} />

            <div className="content" id="contents">
                <div style={{
                    maxWidth: "480px",
                    margin: "0 auto",
                    padding: "0 4px",
                    height: "calc(100dvh - 4.5rem)",
                    overflowY: "auto",
                    background: "#f5f6f8",
                }}>

                    {/* 결제 방법 */}
                    <div style={sectionStyle}>
                        <div style={sectionTitle}>결제 방법</div>
                        <div style={{
                            border: "2px solid #3182F6",
                            borderRadius: "8px",
                            padding: "10px",
                            textAlign: "center",
                            color: "#3182F6",
                            fontWeight: "600",
                            fontSize: "15px",
                        }}>
                            수기결제
                        </div>
                    </div>

                    {/* 상품 정보 */}
                    <div style={sectionStyle}>
                        <div style={sectionTitle}>상품 정보</div>

                        {/* 잠긴 셀렉트박스 */}
                        <div style={fieldWrap}>
                            <select
                                disabled
                                style={{ ...selectStyle, color: "#aaa", background: "#fafafa" }}
                            >
                                <option>직접입력 하세요.</option>
                            </select>
                        </div>

                        {/* 상품명 */}
                        <div style={fieldWrap}>
                            <label style={labelStyle}>상품명</label>
                            <input
                                type="text"
                                name="GoodsName"
                                placeholder="상품명을 입력해주세요."
                                value={formData.GoodsName}
                                onChange={handleChange}
                                style={inputStyle}
                            />
                        </div>

                        {/* 판매가격 / 판매수량 */}
                        <div style={rowStyle}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>판매가격</label>
                                <input
                                    type="text"
                                    placeholder="판매가격을 입력해주세요."
                                    value={displayPrice}
                                    onChange={handlePriceChange}
                                    style={inputStyle}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>판매수량</label>
                                <input
                                    type="text"
                                    placeholder="수량을 입력해주세요."
                                    value={formData.qty}
                                    onChange={handleQtyChange}
                                    style={inputStyle}
                                />
                            </div>
                        </div>

                        {/* 결제금액 합계 */}
                        <div style={fieldWrap}>
                            <label style={labelStyle}>결제금액 합계</label>
                            <div style={{
                                ...inputStyle,
                                background: "#f3f4f6",
                                color: "#111",
                                fontWeight: "700",
                                minHeight: "42px",
                                display: "flex",
                                alignItems: "center",
                            }}>
                                {displayTotal}
                            </div>
                        </div>
                    </div>

                    {/* 판매자 정보 */}
                    <div style={sectionStyle}>
                        <div style={sectionTitle}>판매자 정보</div>
                        <div style={fieldWrap}>
                            <label style={labelStyle}>가맹점명</label>
                            <div style={{
                                ...inputStyle,
                                background: "#f3f4f6",
                                color: "#111",
                                fontWeight: "500",
                            }}>
                                {userData?.co_nm || ""}
                            </div>
                        </div>
                    </div>

                    {/* 결제 정보 */}
                    <div style={sectionStyle}>
                        <div style={sectionTitle}>결제 정보</div>

                        {/* 개인카드 / 사업자(법인)카드 체크박스 */}
                        <div style={{ display: "flex", gap: "20px", marginBottom: "16px" }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }}>
                                <input
                                    type="checkbox"
                                    checked={formData.card_gubun === "개인"}
                                    onChange={() => setFormData(prev => ({ ...prev, card_gubun: "개인", IDNo: "" }))}
                                    style={{ width: "18px", height: "18px", accentColor: "#3182F6" }}
                                />
                                개인카드
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500" }}>
                                <input
                                    type="checkbox"
                                    checked={formData.card_gubun === "사업자"}
                                    onChange={() => setFormData(prev => ({ ...prev, card_gubun: "사업자", IDNo: "" }))}
                                    style={{ width: "18px", height: "18px", accentColor: "#3182F6" }}
                                />
                                사업자(법인)카드
                            </label>
                        </div>

                        {/* 카드번호 */}
                        <div style={fieldWrap}>
                            <label style={labelStyle}>카드번호</label>
                            <input
                                type="text"
                                placeholder="0000-0000-0000-0000"
                                value={cardDisplay}
                                onChange={handleCardNumChange}
                                style={{ ...inputStyle, ...(cardError ? { borderColor: "#dc3545" } : {}) }}
                                maxLength={19}
                                inputMode="numeric"
                            />
                            {cardError && (
                                <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>{cardError}</div>
                            )}
                            {(bank || cardPolicyNotice) && (
                                <div style={{ color: isCardBlocked ? "#dc3545" : "#2563eb", fontSize: "12px", marginTop: "4px", fontWeight: "600" }}>
                                    {cardPolicyNotice || bank}
                                </div>
                            )}
                        </div>

                        {/* MM / YY */}
                        <div style={rowStyle}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>MM</label>
                                <input
                                    type="text"
                                    name="ExpMonth"
                                    placeholder="MM"
                                    maxLength={2}
                                    value={formData.ExpMonth}
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>YY</label>
                                <input
                                    type="text"
                                    name="ExpYear"
                                    placeholder="YYYY"
                                    maxLength={4}
                                    value={formData.ExpYear}
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                            </div>
                        </div>

                        {/* 비밀번호 / 할부개월 */}
                        <div style={rowStyle}>
                            {!isKayu && (
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>비밀번호</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <input
                                            type="password"
                                            name="CardPw"
                                            placeholder="XX"
                                            maxLength={2}
                                            autoComplete="new-password"
                                            value={formData.CardPw}
                                            onChange={handleChange}
                                            style={{ ...inputStyle, width: "60px", textAlign: "center", flex: "none" }}
                                        />
                                        <span style={{ fontSize: "16px", color: "#999", letterSpacing: "2px" }}>**</span>
                                    </div>
                                </div>
                            )}
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>할부개월</label>
                                <select
                                    name="CardQuota"
                                    value={formData.CardQuota}
                                    onChange={handleChange}
                                    style={selectStyle}
                                >
                                    {currentQuotaOptions.map((option) => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* 연락처 */}
                        <div style={fieldWrap}>
                            <label style={labelStyle}>연락처</label>
                            <div style={{ display: "flex", gap: "8px" }}>
                                <select
                                    name="phonePre"
                                    value={formData.phonePre}
                                    onChange={handleChange}
                                    style={{ ...selectStyle, width: "90px", flex: "none" }}
                                >
                                    <option value="010">010</option>
                                    <option value="011">011</option>
                                    <option value="016">016</option>
                                    <option value="017">017</option>
                                    <option value="018">018</option>
                                    <option value="019">019</option>
                                </select>
                                <input
                                    type="text"
                                    placeholder="연락처를 입력해주세요."
                                    value={formData.phoneBody}
                                    onChange={handlePhoneBodyChange}
                                    style={inputStyle}
                                    maxLength={8}
                                />
                            </div>
                        </div>

                        {/* 이름 */}
                        <div style={fieldWrap}>
                            <label style={labelStyle}>이름</label>
                            <input
                                type="text"
                                name="BuyerName"
                                placeholder="이름을 입력해주세요."
                                value={formData.BuyerName}
                                onChange={handleChange}
                                style={inputStyle}
                                maxLength={20}
                            />
                        </div>

                        {/* 개인: 생년월일 / 사업자: 사업자등록번호 (kayu 시 숨김) */}
                        {!isKayu && formData.card_gubun === "개인" && (
                            <div style={fieldWrap}>
                                <label style={labelStyle}>생년월일 (YYMMDD)</label>
                                <input
                                    type="text"
                                    placeholder="6자리 생년월일을 입력해주세요."
                                    value={formData.IDNo}
                                    onChange={(e) => {
                                        let numeric = e.target.value.replace(/\D/g, "").slice(0, 6);
                                        setFormData(prev => ({ ...prev, IDNo: numeric }));
                                    }}
                                    style={inputStyle}
                                    maxLength={6}
                                />
                            </div>
                        )}
                        {!isKayu && formData.card_gubun === "사업자" && (
                            <div style={fieldWrap}>
                                <label style={labelStyle}>사업자등록번호 (000-00-00000)</label>
                                <input
                                    type="text"
                                    placeholder="10자리 사업자등록번호를 입력해주세요."
                                    value={formData.IDNo}
                                    onChange={handleIDNoChange}
                                    style={inputStyle}
                                    maxLength={10}
                                />
                            </div>
                        )}
                    </div>

                    {/* 하단 여백 (버튼 가림 방지) */}
                    <div style={{ height: "80px" }} />
                </div>

                {/* 하단 고정 버튼 */}
                <div style={{
                    position: "fixed",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 50,
                    padding: "10px 12px calc(10px + env(safe-area-inset-bottom))",
                    maxWidth: "480px",
                    margin: "0 auto",
                }}>
                    <button
                        type="button"
                        onClick={onSubmitSugi}
                        disabled={!isFormValid || isSubmitting}
                        style={{
                            width: "100%",
                            border: "none",
                            borderRadius: "12px",
                            padding: "14px 10px",
                            background: isFormValid ? "#3182F6" : "#8a8d91",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "16px",
                            cursor: isFormValid ? "pointer" : "not-allowed",
                        }}
                    >
                        {isSubmitting ? "요청중..." : (validationMsg || "결제하기")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SugiInbiz;
